import { ComponentType } from 'react'

const SortableOverLayContent: ComponentType<any> = () => {
  return (
    <span style={{ cursor: 'grabbing' }}>
      <strong>::::::</strong>
    </span>
  )
}

export default SortableOverLayContent
